import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  HostListener,
  input,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { LoadingDirective } from '@iupics-components/directives/loading.directive';
import { QuickActionData, QuickActionSubData, QuickActionTypeIconMapping } from './quick-action-data';

@Component({
  selector: 'iu-quick-action',
  templateUrl: './quick-action.component.html',
  styleUrls: ['./quick-action.component.scss'],
  standalone: true,
  imports: [LoadingDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class QuickActionComponent implements AfterViewInit {
  readonly data = input<QuickActionData>();
  readonly clickEmitter = output<QuickActionData>();

  @ViewChild('qaElement', { read: ElementRef<HTMLElement> }) qaElement: ElementRef<HTMLElement>;

  isExpanded = signal(false);

  readonly icon = computed(() => QuickActionTypeIconMapping[this.data()?.type]);

  ngAfterViewInit(): void {
    this.handleEvents();
  }

  changeExpansionState(value: boolean): void {
    if (this.data()?.subActions?.length > 0 && !this.data()?.readonly) {
      this.isExpanded.set(value);
    }
  }

  applyFunction(target: QuickActionData | QuickActionSubData): void {
    if (this.data()?.readonly) {
      return;
    }

    if (this.data()?.action) {
      this.data().action(target);
    } else {
      this.clickEmitter.emit(this.data());
    }

    this.changeExpansionState(false);
  }

  @HostListener('window:resize', ['$event'])
  handleEvents(): void {
    if (window.innerWidth >= 1024) {
      this.handleMouseEvents();
    } else {
      this.handleTouchEvents();
    }
  }

  handleMouseEvents(): void {
    let timer = null;
    const duration = 0;
    if (this.qaElement?.nativeElement) {
      this.qaElement.nativeElement.onmouseenter = (): void => {
        if (timer) {
          clearTimeout(timer);
        }

        this.changeExpansionState(true);
      };
    }

    if (this.qaElement?.nativeElement) {
      this.qaElement.nativeElement.onmouseleave = (): void => {
        timer = setTimeout(() => this.changeExpansionState(false), duration);
      };
    }
  }

  handleTouchEvents(): void {
    let timer = null;
    const touchDuration = 200;

    if (this.qaElement?.nativeElement) {
      this.qaElement.nativeElement.ontouchstart = (): void => {
        timer = setTimeout(() => {
          this.changeExpansionState(true);
          window.navigator.vibrate(10);
        }, touchDuration);
      };
    }

    if (this.qaElement?.nativeElement) {
      this.qaElement.nativeElement.ontouchend = (): void => {
        if (timer) {
          clearTimeout(timer);
        }
      };
    }
  }
}
